import { getAttributesQueryCache } from 'Api'
import { store } from 'store/reducers'

type ResourceType =
  | 'attributes'
  | 'positions'
  | 'departments'
  | 'projects'
  | 'teams'
  | 'hiringData'
  | 'regionalTags'
  | 'alerts'
  | 'requirements'
  | 'skills'
  | 'restrictions'
  | 'permissions'

const hasRessources = (type: ResourceType): boolean => {
  const attributes = getAttributesQueryCache()?.attributes ?? []
  const {
    resources: { positions, projects, teams, hiringData, tags, departments, permissions }
  } = store.getState() as MStore.RootState

  const resources = {
    attributes,
    positions,
    projects,
    teams,
    hiringData,
    regionalTags: tags.filter(tag => tag.type === 'regional'),
    departments,
    alerts: attributes.filter(alert => alert.type === 'alert'),
    requirements: attributes.filter(requirement => requirement.type === 'requirement'),
    skills: attributes.filter(skill => skill.type === 'skill'),
    restrictions: attributes.filter(restriction => restriction.type === 'restriction'),
    permissions
  }

  return resources[type].length > 0
}

export default hasRessources
